import {PendingPasteAttachment} from "./pasteAttachments";

const DRAFT_RESTORE_EVENT = "chat-draft-restore";

export interface DraftRestoreDetail {
    entityId: string;
    message: string;
    attachments: PendingPasteAttachment[];
}

export const requestDraftRestore = (detail: DraftRestoreDetail) => {
    window.dispatchEvent(new CustomEvent(DRAFT_RESTORE_EVENT, {detail}));
};

export const subscribeToDraftRestore = (
    listener: (detail: DraftRestoreDetail) => void
) => {
    const handler = (event: Event) =>
        listener((event as CustomEvent<DraftRestoreDetail>).detail);
    window.addEventListener(DRAFT_RESTORE_EVENT, handler);
    return () => window.removeEventListener(DRAFT_RESTORE_EVENT, handler);
};
